import {fetch} from '../../utils/dataAccess';

export default async function deleteReceipt(receiptId) {
    await fetch(`/receipts/${receiptId}`, {method: 'DELETE'});
}
